import {combineReducers} from 'redux';

import userReducer from './userReducer';
import universalReducer from './universalReducer';
import cartReducer from './cartReducer';
import productsReducer from './productsReducer';
import adminReducer from './adminReducer';
import categoryReducer from './categoryReducer';
import ordersReducer from './ordersReducer';
import accountsReducer from './accountsReducer';
import signReducer from './signReducer';
import storeReducer from './storeReducer';

//Front Ends
import homeReducer from './homeReducer';
import aboutReducer from './aboutReducer';
import companyReducer from './companyReducer';
import communityReducer from './communityReducer';

import modalReducer from './modalReducer';
import mypageReducer from './mypageReducer';


import {firebaseReducer} from 'react-redux-firebase';

export default combineReducers({
    user : userReducer,
    universal : universalReducer,
    products : productsReducer,
    cart : cartReducer,
    admin : adminReducer,
    category : categoryReducer,
    orders : ordersReducer,
    accounts : accountsReducer,
    sign : signReducer,
    store : storeReducer,
    firebase : firebaseReducer,
    
    home : homeReducer,
    about : aboutReducer,
    company : companyReducer,
    community : communityReducer,
    modals : modalReducer,
    mypage : mypageReducer,
})


// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js